import {Map, fromJS} from 'immutable';
import moment from 'moment';
import 'moment-timezone';

import * as action from '../actions';

const defaultSettings = {
	interval: 30,
	open: 14,
	close: 26,
	safeTime: 0,
	hookahHour: 60,
	maxHookahHours: 3,
	maxBookings: 1,
	timezone: 'Europe/Moscow',
	midnight: 6,
	on: false,
	book_off: false,
	theme: 'light',
	color_primary: '#DF0A0A',
};

const initialState = Map({
	ready: false,
	settings: Map({
		loading: true,
		data: fromJS(defaultSettings),
	}),
	momentTimezone: moment(),
	momentTimezoneOffset: moment(),
	uuid: null,
	online: 0,
});

const actionHandlers = {
	[action.ready]: state => {
		return state.merge({
			ready: true
		});
	},
	[action.uuid]: (state, {uuid}) => {
		return state.merge({uuid});
	},

	// настройки
	[action.loadSettings.request]: state => {
		return state.setIn(['settings','loading'], true);
	},
	[action.loadSettings.success]: (state, {data}) => {
		const newData = {
			...defaultSettings,
			...data,
		};
		return state
			.setIn(['settings','loading'], false)
			.setIn(['settings','data'], fromJS(newData));
	},
	[action.loadSettings.failure]: state => {
		return state.setIn(['settings','loading'], false);
	},

	// online widget
	[action.online]: (state, {count}) => {
		return state.merge({online: count});
	},

	// moment timezone offset
	[action.moment]: (state, {momentTimezone, momentTimezoneOffset}) => {
		return state
			.setIn(['momentTimezone'], momentTimezone)
			.setIn(['momentTimezoneOffset'], momentTimezoneOffset);
	},
};

export {initialState, actionHandlers};
export default createReducer => createReducer(initialState, actionHandlers);



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js